import React from 'react';
import Grid from 'material-ui/Grid';
import APP_CONFIG from '../config/app.json';
const companyList = () => {
  return (
    <div className="company-list bg-base-color">
      <div className="container company-list-container">
      <Grid container spacing={0}>
        <Grid item xs={12}>
          {/* <div className="sns">
            <a className="facebook-link left" href="https://www.facebook.com/jln.co.jp/" rel="noopener noreferrer" target="_blank">
              <svg className="facebook-icon" viewBox="0 0 512 512"><path d="M211.9 197.4h-36.7v59.9h36.7V433.1h70.5V256.5h49.2l5.2-59.1h-54.4c0 0 0-22.1 0-33.7 0-13.9 2.8-19.5 16.3-19.5 10.9 0 38.2 0 38.2 0V82.9c0 0-40.2 0-48.8 0 -52.5 0-76.1 23.1-76.1 67.3C211.9 188.8 211.9 197.4 211.9 197.4z"/></svg>
            </a>
          </div> */}
        </Grid>
      </Grid>
      <Grid container spacing={0}>
        {
          
          APP_CONFIG.company_list.map((value,key) => {
            return (
              <Grid item sm={4} xs={12} key={key}>
                <dl className="company-item">
                  <dt>{value.name}</dt>
                  <dd>{value.address}</dd>
                  <dd>TEL.{value.tel} / FAX.{value.fax}</dd>
                </dl>
              </Grid>
            );
          })
        }
      </Grid>
      </div>
    </div>
  )
}

export default companyList;


// WEBPACK FOOTER //
// ./src/component/CompanyList.js